import apiRequest from './apiRequest';

export type MediaUploadItem = {
  extension: string;
  name: string;
  duration?: number;
  resolution?: string;
};

export type MediaUploadResponseItem = {
  mediaID: string;
  extension: string;
  name: string;
  mediaUploadURL: string;
  thumbnailUploadURL: string;
};

type MediaUploadPayload = {
  createdByUser: string;
  media: MediaUploadItem[];
};

type MediaUploadResponse = {
  mediaUploads: MediaUploadResponseItem[];
};

export default async function postMediaUpload(
  createdByUser: string,
  media: MediaUploadItem[],
  apiKey: string,
) {
  return await apiRequest<MediaUploadResponse>(
    'external-mogen',
    '/media/upload',
    {
      method: 'POST',
      body: JSON.stringify({ createdByUser, media } satisfies MediaUploadPayload),
      headers: {
        'x-api-key': apiKey,
      },
    },
  );
}
